import { FC, SVGProps } from 'react';

export const ArrowLeftIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			d="M20.8132 7.81315C21.2623 7.36405 21.2623 6.63591 20.8132 6.1868C20.3641 5.7377 19.636 5.7377 19.1869 6.1868L10.1869 15.1868C9.73776 15.6359 9.73776 16.364 10.1869 16.8131L19.1869 25.8131C19.636 26.2623 20.3641 26.2623 20.8132 25.8131C21.2623 25.364 21.2623 24.6359 20.8132 24.1868L12.6264 16L20.8132 7.81315Z"
			fill="currentColor"
		/>
	</svg>
);
